import request from '../utils/request';

// 平台代售订单 API
export const platformSalesOrderApi = {
  // 分页查询平台代售订单列表
  // params: { page, size, userId, status }
  getPlatformSalesOrderList: (params) => request.get('/platform-sales-order', { params }),
  
  // 获取平台代售订单详情
  getPlatformSalesOrderDetail: (id) => request.get(`/platform-sales-order/${id}`),
  
  // 创建平台代售订单
  createPlatformSalesOrder: (data) => request.post('/platform-sales-order', data),
  
  // 更新平台代售订单
  updatePlatformSalesOrder: (id, data) => request.put(`/platform-sales-order/${id}`, data),
  
  // 删除平台代售订单（软删除）
  deletePlatformSalesOrder: (id) => request.delete(`/platform-sales-order/${id}`),
  
  // 同意代售申请
  // POST /platform-sales-order/{id}/accept
  acceptOrder: (id) => request.post(`/platform-sales-order/${id}/accept`),
  
  // 拒绝代售申请
  // POST /platform-sales-order/{id}/reject
  // data: { rejectReason: string }
  rejectOrder: (id, data) => request.post(`/platform-sales-order/${id}/reject`, data),
  
  // 确认送到平台
  // POST /platform-sales-order/{id}/confirm
  confirmOrder: (id) => request.post(`/platform-sales-order/${id}/confirm`),
  
  // 退还代售商品
  // POST /platform-sales-order/{id}/return
  // data: { returnReason: string }
  returnOrder: (id, data) => request.post(`/platform-sales-order/${id}/return`, data),
  
  // 结算订单（打款给用户）
  // POST /platform-sales-order/{id}/settle
  // data: { amount: number, fee?: number, paymentMethod: string, remark?: string }
  settleOrder: (id, data) => request.post(`/platform-sales-order/${id}/settle`, data)
};

